import { ChevronDown, MessageCircleQuestion } from "lucide-react";
import { useTranslation } from "react-i18next";
import { SectionShell } from "./SectionShell";

const QUESTIONS = [1, 2, 3, 4, 5, 6] as const;

/**
 * よくあるご質問。文言は index_faq の原文のまま。
 * 6問ぶんの答えを常時出すと縦に伸びるので畳んである（開けば全文が出る）。
 */
export const FaqSection = () => {
  const { t } = useTranslation();

  return (
    <SectionShell
      id="faq"
      icon={<MessageCircleQuestion aria-hidden="true" focusable="false" />}
      heading={t("index_faq.heading")}
    >
      <div className="faq-grid">
        {QUESTIONS.map((n) => (
          <details className="faq-item" key={n} data-reveal>
            <summary>
              <span>{t(`index_faq.q${n}_title`)}</span>
              <ChevronDown aria-hidden="true" focusable="false" />
            </summary>
            <p>{t(`index_faq.a${n}`)}</p>
          </details>
        ))}
      </div>
    </SectionShell>
  );
};
